<script>


import {useVuelidate} from '@vuelidate/core'
import {required, requiredIf, helpers} from '@vuelidate/validators'

import {api as viewerApi} from "v-viewer"

export default {
  inject: ['$Q', '$DateTime', '$axios', '$_', '$ApexCharts'],
  setup() {
    return {v$: useVuelidate()}
  },
  props: {
    profileID: String,
    loginData: Object,
    caseStage: String,
  },
  data() {
    return {
      profileSubmittedMsg: '',
      showFundPositionChart: false,
      showLoadingAnimation: false,
      approvalRemarksPlaceHolder: '',
      profileSubmitted: false,
      currentData: {},
      profileLoading: true,
      profileLoadingText: 'Retrieving Profile data',
      activeProfile: {},
      faceImages: [],
      conditionImages: [],
      waiverImages: [],
      identificationImages: [],
      additionalFiles: [],
      feedbackViewBtn: '',
      profileTS: '',
      profileComment: '',
      profilePartner: '',
      profileApproval: {
        status: '',
        reason: '',
        fundingPocket: '',
        fundingPocketWatsi: '',
        fundingPocketFundManagerApproved: ''
      },
      profileQA: {
        dataQuality: {
          rating: '',
          comment: ''
        },
        storyQuoteQuality: {
          rating: '',
          comment: ''
        },
        imageQuality: {
          rating: '',
          comment: ''
        },
        waiverQuality: {
          rating: '',
          comment: ''
        },
      },
      disableQASaving: false,
      disableCommentSaving: false,
      commentsArr: [],
      isReadOnly: false,
    }
  },
  components: {},
  validations() {
    let vm = this,
        validationObj = {};
    switch (vm.feedbackView) {
      case 'RateAndApprove':
        validationObj = {
          profileApproval: {
            status: {required: helpers.withMessage("Please select the approval status of the profile", required)},
            reason: {requiredIfProfileNotApproved: helpers.withMessage("Please provide the reason for the approval status", requiredIf(vm.profileApproval.status === 'profilereturned' || vm.profileApproval.status === 'profilerejected'))},
            fundingPocket: {requiredIfProfileApproved: helpers.withMessage("Please provide the source of funds for this surgery", requiredIf(vm.profileApproval.status === 'profileapproved'))},
            fundingPocketWatsi: {requiredIfProfileApprovedInWatsi: helpers.withMessage("Please provide the Watsi ID of the case", requiredIf(vm.profileApproval.fundingPocket === 'watsi'))},
            fundingPocketFundManagerApproved: {requiredIfFundingFromInternal: helpers.withMessage("Please provide the fund manager response", requiredIf(vm.profileApproval.fundingPocket === 'contingencyfund'))}
          },
          profileQA: {
            dataQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the data quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {requiredIfRatingPoor: helpers.withMessage("Please provide the data quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.dataQuality.rating <= 2))}
            },
            storyQuoteQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the story and quote quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the story and quote quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.storyQuoteQuality.rating <= 2))}
            },
            imageQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the images quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the images quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.imageQuality.rating <= 2))}
            },
            waiverQuality: {
              rating: {requiredIfProfileApproved: helpers.withMessage("Please provide the rating for the waiver quality", requiredIf(vm.profileApproval.status === 'profileapproved'))},
              comment: {required: helpers.withMessage("Please provide the waiver quality comment", requiredIf(vm.profileApproval.status === 'profileapproved' && vm.profileQA.waiverQuality.rating <= 2))}
            }
          }
        }
        break;
      case 'commentOnly':
        validationObj = {
          profileComment: {required: helpers.withMessage("Please provide the comment text", required)}
        }
        break;
    }
    return validationObj;
  },
  methods: {
    async validateForm() {
      await this.v$.$validate();
    },
    resize(textAreaRef) {
      let vm = this;
      let element = vm.$refs[textAreaRef];
      element.style.height = "18px";
      element.style.height = element.scrollHeight + "px";
    },
    showFundsLimits: function () {
      let vm = this;
      let options = {
        series: [
          {
            name: 'Fund Limit',
            group: 'Limit',
            data: [72000, 100000, 10000]
          },
          {
            name: 'Approved',
            group: 'approval',
            data: [30000, 20000, 2000]
          },
          {
            name: 'Awaiting',
            group: 'approval',
            data: [35000, 60000, 3000]
          }
        ],
        chart: {
          type: 'bar',
          height: 300,
          stacked: true,
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        dataLabels: {
          formatter: (val) => {
            return val / 1000 + 'K'
          }
        },
        plotOptions: {
          bar: {
            horizontal: true
          }
        },
        xaxis: {
          categories: [
            'Watsi',
            'AMH Fund',
            'Contingency'
          ],
          labels: {
            formatter: (val) => {
              return val / 1000 + 'K'
            }
          }
        },
        fill: {
          opacity: 1,
        },
        colors: ['#008FFB', '#00E396', '#80f1cb'],
        legend: {
          position: 'top',
          horizontalAlign: 'left'
        }
      };

      let chart = new vm.$ApexCharts(document.querySelector("#fundPositionChart"), options);
      chart.render();
      vm.showLoadingAnimation = false;
    },
    fetchComments: function () {
      let vm = this;
      try {
        vm.$axios
            .post('/profile/action/fetchComments', {
              profileTS: vm.profileTS
            }, {
              headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${vm.currentData.token}`
              }
            })
            .then(function (response) {
              switch (response.data.success) {
                case 'true':
                  vm.commentsArr = response.data.comments;
                  break;
                case 'false':
                  vm.commentsArr = [];
                  break;
              }
            });
      } catch (error) {
        console.error(error);
      }
    },
    previewURL(imageSource, initialViewIndex) {

      let vm = this;
      viewerApi({
        options: {
          "inline": false,
          "button": true,
          "navbar": true,
          "title": true,
          "toolbar": true,
          "tooltip": true,
          "movable": true,
          "zoomable": true,
          "rotatable": true,
          "scalable": true,
          "transition": true,
          "fullscreen": true,
          "keyboard": true,
          "url": "data-source",
          initialViewIndex: initialViewIndex
        },
        images: vm.sourceImageURLs[imageSource]
      })
    },
  },
  computed: {
    isWatsiCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'watsi';
    },
    isFundManagerCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'contingencyfund';
    },
    isOtherCase() {
      let vm = this;
      return vm.showFundPositionChart && vm.profileApproval.fundingPocket === 'amhother';
    },
    feedbackView() {
      let vm = this,
          returnValue = 'commentOnly';
      if (vm.dataFrom === 'rejectedProfile') {
        returnValue = 'commentOnly'
      } else {
        if (vm.feedbackViewBtn === '') {
          switch (vm.currentData.role) {
            case 'Representative':
              returnValue = 'commentOnly'
              break;
            case 'Coordinator':
              returnValue = 'RateAndApprove'
              break;
          }
        } else {
          returnValue = vm.feedbackViewBtn;
        }
      }

      return returnValue;
    },
    sourceImageURLs() {
      let vm = this;
      let imageURLs = {preop: [], condition: [], ids: [], attachments: []};
      vm.$_.forEach(vm.activeProfile.faceImages, function (faceImage) {
        imageURLs.preop.push({
          'src': faceImage.view,
          'data-source': faceImage.view,
        });
      });
      vm.$_.forEach(vm.activeProfile.conditionImages, function (conditionImage) {
        imageURLs.condition.push({
          'src': conditionImage.view,
          'data-source': conditionImage.view,
        });
      });
      vm.$_.forEach(vm.activeProfile.identificationImages, function (identificationImage) {
        imageURLs.ids.push({
          'src': identificationImage.view,
          'data-source': identificationImage.view,
        });
      });
      imageURLs.attachments.push({
        'src': vm.activeProfile.waiverImages[0].view,
        'data-source': vm.activeProfile.waiverImages[0].view,
      });
      vm.$_.forEach(vm.activeProfile.additionalAttachments, function (additionalAttachment) {
        imageURLs.attachments.push({
          'src': additionalAttachment.view,
          'data-source': additionalAttachment.view,
        });
      });
      return imageURLs;
    }
  },
  watch: {
    profileApproval: {
      handler(newValue,) {
        let vm = this;
        if (!vm.showFundPositionChart) {
          if (newValue.status === 'profileapproved') {
            vm.showFundPositionChart = true;
            vm.showLoadingAnimation = true;
            vm.approvalRemarksPlaceHolder = 'Any additional remarks';
            setTimeout(function () {
              vm.showFundsLimits();
            }, 3000)
          }
        }

        if (vm.showFundPositionChart) {
          if (newValue.status === 'profilereturned' || newValue.status === 'profilerejected') {
            vm.showFundPositionChart = false;
            vm.profileApproval.fundingPocket = '';
            vm.profileApproval.fundingPocketWatsi = '';
            vm.profileApproval.fundingPocketFundManagerApproved = '';
          }
          if (newValue.status === 'profilereturned') {
            vm.approvalRemarksPlaceHolder = 'Reason for sending back the profile';
          }
          if (newValue.status === 'profilerejected') {
            vm.approvalRemarksPlaceHolder = 'Reason for rejecting the profile';
          }
        }

      },
      deep: true
    }
  },
  async mounted() {
    let vm = this;
    const storedAccount = localStorage.getItem("account");
    vm.currentData = JSON.parse(storedAccount);

    vm.IDB = await vm.getIDB();

    let
        unapprovedProfilePatient,
        approvedProfilePatient,
        rejectedProfilePatient;
    switch (vm.dataFrom) {
      case 'submittedProfile':


        unapprovedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'unapprovedProfiles', vm.profileID, 'caseId', false);


        if (typeof unapprovedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = unapprovedProfilePatient[0].caseData;
          vm.profilePartner = unapprovedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = false;
        break;
      case 'approvedProfile':

        approvedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'approvedProfiles', vm.profileID, 'caseId', false);


        if (typeof approvedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = approvedProfilePatient[0].caseData;
          vm.profilePartner = approvedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = false;
        break;
      case 'rejectedProfile':


        rejectedProfilePatient = await vm.getPatientFromDb(vm.IDB, 'rejectedProfiles', vm.profileID, 'caseId', false);


        if (typeof rejectedProfilePatient[0] !== 'undefined') {
          vm.profileTS = vm.$_.split(vm.profileID, '-')[1];
          vm.activeProfile = rejectedProfilePatient[0].caseData;
          vm.profilePartner = rejectedProfilePatient[0].caseData.partnerid;
          vm.profileLoading = false;
          vm.fetchComments()
        } else {
          vm.profileLoadingText = 'Profile data was not found';
        }


        vm.isReadOnly = true;
        break;
    }


  },
};
</script>

<template>
  <div class="profile-form-container" v-if="profileLoading">
    {{ profileLoadingText }}
  </div>
  <div class="profile-form-container" v-else>
    <div class="container">
      <div class="columns is-multiline is-mobile is-vcentered">

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Case Data</div>
            </div>

            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-centered">Case ID:</label>
            </div>
            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-left">{{ activeProfile.profileIdentifier }}</label>
            </div>

            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-centered">Partner:</label>
            </div>
            <div class="column is-half has-text-left label-no-padding-bottom label-no-padding-top full-width-cell-last">
              <label class="label has-text-left">{{ activeProfile.partnerIdentity }}</label>
            </div>

          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Patient Information</h1>
        </div>

        <div class="column is-full">
          <div id="personalOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Personal</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Full Name</label>
                    <div class="has-text-centered">{{ activeProfile.patientName }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Patient Hospital Number</label>
                    <div class="has-text-centered">{{ activeProfile.inpatientNumber }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Gender</label>
                    <div class="has-text-centered">{{ activeProfile.patientGender }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Date of Birth</label>
                    <div class="has-text-centered">{{ activeProfile.patientDob }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Marital Status</label>
                    <div class="has-text-centered">{{ activeProfile.patientMarital }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Education Level</label>
                    <div class="has-text-centered">{{ activeProfile.patientEducation }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Patient Descriptor</label>
                    <div class="has-text-centered">{{ activeProfile.patientDescription }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Has Health Insurance</label>
                    <div class="has-text-centered">{{ activeProfile.hasInsurance }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Phone Number of the Patient</label>
                    <div class="has-text-centered">{{ activeProfile.patientPhoneNumber }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Government Identification</label>
                    <div class="has-text-centered">{{ activeProfile.identificationDocument }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.patientAgeGroup ==='Minor'"></div>
        <div class="column is-full" v-if="activeProfile.patientAgeGroup ==='Minor'">
          <div id="personalTwo" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text" v-if="activeProfile.guardianIsNok==='No'">Guardian</div>
              <div class="section-box-title-text" v-if="activeProfile.guardianIsNok==='Yes'">Guardian and Next of Kin
              </div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Guardian Name</label>
                    <div class="has-text-centered">{{ activeProfile.guardianName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Guardian Phone Number</label>
                    <div class="has-text-centered">{{ activeProfile.guardianPhone }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Relationship</label>
                    <div class="has-text-centered">{{ activeProfile.guardianRelation }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"
             v-if="activeProfile.guardianIsNok==='No' || activeProfile.patientAgeGroup ==='Adult'"></div>
        <div class="column is-full"
             v-if="activeProfile.guardianIsNok==='No' || activeProfile.patientAgeGroup ==='Adult'">
          <div id="personalThree" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Next of Kin</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Name</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinName }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Phone Number</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinPhone }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Relationship</label>
                    <div class="has-text-centered">{{ activeProfile.nextOfKinRelation }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalFour" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Origin</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Location and District of Origin</label>
                    <div class="has-text-centered">{{ activeProfile.patientOrigin }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Nearest Health Center</label>
                    <div class="has-text-centered">{{ activeProfile.closestHealthCenter }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Referral From</label>
                    <div class="has-text-centered">{{ activeProfile.referralFrom }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalFive" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Privacy</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td colspan="2">
                    <label class="label has-text-left">Has requested for privacy</label>
                    <div class="has-text-centered" v-html="activeProfile.patientPrivacy"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Social Economic</h1>
        </div>

        <div class="column is-full">
          <div id="personalSix" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Employment</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Employment details of the {{
                        activeProfile.patientOrGuardian
                      }}</label>
                    <div class="has-text-centered">
                      <strong>Profile: </strong>{{ activeProfile.employmentProfile }}
                      <span v-if="activeProfile.employmentType!=='-'"><br><strong>Type: </strong>{{
                          activeProfile.employmentType
                        }}</span>
                      <br><strong>Description: </strong>
                      <span v-if="activeProfile.employmentDescription!=='-'">
                      {{ activeProfile.employmentDescription }}
                    </span>
                      <span v-if="activeProfile.selfemploymentDescription!=='-'">
                      {{ activeProfile.selfemploymentDescription }}
                    </span>
                    </div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Monthly income of the {{ activeProfile.patientOrGuardian }}
                      (USD)</label>
                    <div class="has-text-centered">{{ activeProfile.monthlyIncome }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalSeven" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Housing</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Type of Housing</label>
                    <div class="has-text-centered">{{ activeProfile.housingType }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Number of rooms</label>
                    <div class="has-text-centered">{{ activeProfile.houseRooms }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="personalEight" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Energy</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">The main source of power (Lighting)</label>
                    <div class="has-text-centered">{{ activeProfile.lightingEnergy }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">The main source of energy (cooking)</label>
                    <div class="has-text-centered">{{ activeProfile.cookingEnergy }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Family</h1>
        </div>

        <div class="column is-full">
          <div id="personalNine" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Household</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Number of household members the {{
                        activeProfile.patientOrGuardian
                      }}
                      supports</label>
                    <div class="has-text-centered">{{ activeProfile.supportingHouseHoldOf }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Number of Children the {{ activeProfile.patientOrGuardian }}
                      has</label>
                    <div class="has-text-centered">{{ activeProfile.numberOfChildren }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-mobile is-vcentered">
        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Illness Profile</h1>
        </div>
        <div class="column is-full">
          <div id="illnessOne" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Surgery</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Condition</label>
                    <div class="has-text-centered">{{ activeProfile.patientCondition }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Length of stay with condition</label>
                    <div class="has-text-centered">{{ activeProfile.timeWithCondition }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="2">
                    <label class="label has-text-left">Type</label>
                    <div class="has-text-centered">{{ activeProfile.surgeryType }}</div>
                  </td>
                  <td class="middle-table-cell" colspan="2">
                    <label class="label has-text-left">Surgery required</label>
                    <div class="has-text-centered">{{ activeProfile.surgeryRequired }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="2">
                    <label class="label has-text-left">Estimated Date of Surgery</label>
                    <div class="has-text-centered">{{ activeProfile.estimatedSurgeryDay }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Gravidity</label>
                    <div class="has-text-centered">{{ activeProfile.gravidity }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Parity</label>
                    <div class="has-text-centered">{{ activeProfile.parity }}</div>
                  </td>
                </tr>
                <tr>
                  <td class="left-side-table-cell" colspan="3">
                    <label class="label has-text-left">Safe Ask</label>
                    <div class="has-text-centered safe-ask-amount">{{ activeProfile.safeAskAmount }}</div>
                  </td>
                  <td class="right-side-table-cell" colspan="3">
                    <label class="label has-text-left">Co-Payment Amount</label>
                    <div class="has-text-centered" v-html="activeProfile.coPaymentDisplay"></div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessTwo" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Transport</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td class="left-side-table-cell">
                    <label class="label has-text-left">Time taken to reach the hospital</label>
                    <div class="has-text-centered">{{ activeProfile.timeTakenToHospital }}</div>
                  </td>
                  <td class="middle-table-cell">
                    <label class="label has-text-left">Main mode of transport to the hospital</label>
                    <div class="has-text-centered">{{ activeProfile.modeOfTransport }}</div>
                  </td>
                  <td class="right-side-table-cell">
                    <label class="label has-text-left">Amount spent on transport round trip</label>
                    <div class="has-text-centered">{{ activeProfile.costOfTransport }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessThree" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Patient Story</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <div class="has-text-justified">{{ activeProfile.patientStory }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="illnessFour" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Personal Quote</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <div class="has-text-justified">{{ activeProfile.patientQuote }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>
      </div>
    </div>
    <div class="container">
      <div class="columns is-multiline is-mobile">

        <div class="column is-full">
          <h1 class="is-size-3 is-underlined">Patient Photo(s)</h1>
        </div>

        <div class="column is-full" v-if="activeProfile.faceImages.length">
          <div id="AttachmentsTwo" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Pre-OP Photos</div>
            </div>
            <div class="column is-half input-no-padding-top" v-for="(faceImage, index) in activeProfile.faceImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('preop',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${faceImage.thumbnail}`" alt="Patient Face" class="image">
                </div>
              </div>
              <div class="is-centered">Timestamp: <span>{{ faceImage.timestamp }}</span></div>
              <div class="buttons has-addons is-centered">
                <a class="button" v-if="faceImage.location" v-bind:href="faceImage.location"
                   target="_blank">Location</a>
                <a v-bind:href="`${faceImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank" class="button">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.conditionImages.length"></div>
        <div class="column is-full" v-if="activeProfile.conditionImages.length">
          <div id="AttachmentsThree" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Condition</div>
            </div>
            <div class="column is-half input-no-padding-top"
                 v-for="(conditionImage, index) in activeProfile.conditionImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('condition',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${conditionImage.thumbnail}`" alt="Patient Condition"
                       class="image">
                </div>
                <div class="image-flex-container">Timestamp: <span>{{ conditionImage.timestamp }}</span>
                </div>
                <div>Location:
                  <a v-bind:href="conditionImage.location" target="_blank"
                     v-if="conditionImage.location!==''">Here</a>
                  <span v-else></span>
                </div>
                <a v-bind:href="`${conditionImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full" v-if="activeProfile.identificationDocument!=='-'"></div>
        <div class="column is-full" v-if="activeProfile.identificationDocument!=='-'">
          <div id="AttachmentsFour" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Identification Documents</div>
            </div>
            <div class="column is-half input-no-padding-top"
                 v-for="(identificationImage, index) in activeProfile.identificationImages"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('ids',index)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${identificationImage.thumbnail}`"
                       alt="Identification Document"
                       class="image">
                </div>
                <div class="image-flex-container">Timestamp: <span>{{ identificationImage.timestamp }}</span>
                </div>
                <div>Location:
                  <a v-bind:href="identificationImage.location" target="_blank"
                     v-if="identificationImage.location!==''">Here</a>
                  <span v-else></span>
                </div>
                <a v-bind:href="`${identificationImage.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>


        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="additionalAttachments" class="columns is-multiline is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Additional Attachments</div>
            </div>
            <div class="column is-one-quarter">
              <div class="image-relative-container" v-on:click="previewURL('attachments',0)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${activeProfile.waiverImages[0].thumbnail}`" alt="Waiver"
                       class="image">
                </div>
                <a v-bind:href="`${activeProfile.waiverImages[0].download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
            <div class="column is-one-quarter"
                 v-for="(additionalAttachment, index) in activeProfile.additionalAttachments"
                 v-bind:key="index">
              <div class="image-relative-container" v-on:click="previewURL('attachments',index+1)">
                <div class="image-flex-container zoom-image">
                  <img v-bind:src="`${additionalAttachment.thumbnail}`"
                       alt="Additional Attachment"
                       class="image">
                </div>
                <a v-bind:href="`${additionalAttachment.download}?form=profile&fullname=${activeProfile.patientName}`"
                   target="_blank"
                   class="button is-fullwidth">Download</a>
              </div>
            </div>
          </div>
        </div>

        <div class="column is-full"></div>
        <div class="column is-full">
          <div id="AttachmentsSeven" class="columns is-multiline is-mobile is-vcentered section-box">
            <div class="column is-full section-box-title-column">
              <div class="section-box-title-text">Checklist and Confirmation</div>
            </div>
            <div class="column is-full can-scroll-content">
              <table class="table is-striped is-fullwidth">
                <tbody>
                <tr>
                  <td>
                    <label class="label has-text-left">Is the proposed treatment expected to save the patient’s life
                      or significantly increase their standard of living?</label>
                    <div class="has-text-centered">{{ activeProfile.treatmentChangeLife }}</div>
                  </td>
                </tr>
                <tr>
                  <td>
                    <label class="label has-text-left">Do you agree to provide SAFE a complete treatment update within
                      30 days after the proposed treatment date listed in this form?</label>
                    <div class="has-text-centered">{{ activeProfile.treatmentUpdate }}</div>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="column is-full"></div>

      </div>
    </div>
  </div>
</template>

<style>

.black-border {
  border: 2px solid black !important;
}

.left-side-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
}

.right-side-table-cell {
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.middle-table-cell {
  border-right: 1px solid hsl(0, 0%, 86%) !important;
  border-left: 1px solid hsl(0, 0%, 86%) !important;
}

.non-breaking-text {
  white-space: nowrap;
}

.safe-ask-amount {
  font-weight: bold;
  color: #4d9041;
  font-size: xx-large;
}

.full-width-cell-last {
  border-width: 0 0 0 0;
  border-color: black;
  border-style: solid;
}

.section-box {
  border: 1px solid black;
  padding: 5px;
  border-radius: 10px;
}

.section-box-errors {
  border-color: red !important;
}

.section-box-title-column {
  position: relative;
  top: -18px;
  padding: 0 !important;
  margin: 0 !important;
}

.section-box-title-text {
  background-color: white;
  padding: 0 5px;
  width: max-content;
  margin: 0 10px;
  border-radius: 5px;
}

.section-box-title-text-error {
  color: red !important;
}

.label-no-padding-bottom {
  padding-bottom: 0 !important;
}

.label-no-padding-top {
  padding-top: 0 !important;
}

.profile-form-container {
  padding: 20px;
}

.center-screen {
  position: absolute;
  top: 50%;
  left: 50%;
  margin-top: -50px;
  margin-left: -250px;
  width: 500px;
  height: 100px;
}

.image-relative-container {
  padding: 10px;
  position: relative;
}

.image-flex-container {
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.full-width-div {
  width: 100%;
}

.can-scroll-content {
  overflow-x: scroll;
}

.zoom-image img {
  -webkit-transition: all 0s ease;
  -moz-transition: all 0s ease;
  -o-transition: all 0s ease;
  -ms-transition: all 0s ease;
  transition: all 0s ease;
}

.zoom-image:hover img {
  -webkit-transform: scale(5);
  -moz-transform: scale(5);
  -ms-transform: scale(5);
  -o-transform: scale(5);
  transform: scale(5);
}


</style>
